import { HsaReimbursementAccountType } from "@redotech/crdb-enums/conversion/hsa-reimbursement-account-type";
import { HsaReimbursementClaimStatus } from "@redotech/crdb-enums/conversion/hsa-reimbursement-claim-status";
import { hsaAnswer } from "@redotech/redo-conversion-hsa-common/hsa-answer";
import { hsaReimbursementDetails } from "@redotech/redo-conversion-hsa-common/reimbursement/hsa-reimbursement-fields";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const submitHsaReimbursement = {
  name: "submitHsaReimbursement" as const,
  input: z.object({
    orderId: zExt.objectId(),
    provider: z.string().min(1),
    /** Omitted for "Other": the itemized-receipt path is account-type agnostic. */
    accountType: createEnum(HsaReimbursementAccountType).optional(),
    details: hsaReimbursementDetails,
    /** Eligible line item ids to claim. Omitted claims every eligible line; the claim row always stores the explicit list. */
    lineItemIds: z.array(z.string().min(1)).min(1).optional(),
    /** The LMN questionnaire's answers, held by the client; required when `lineItemIds` names an LMN line. */
    lmnAnswers: z.record(z.string(), hsaAnswer).optional(),
    signatureDataUrl: z.string().optional(),
    /** The opt-in checkbox on the sign and review screens; absent keeps the stored value. */
    notifyOpportunities: z.boolean().optional(),
    signatureTimezone: z.string().optional(),
    signatureUserAgent: z.string().optional(),
  }),
  output: z.object({
    claimId: z.string(),
    /** Amount the claim was filed for, after the line selection. */
    eligibleAmount: z.string(),
    status: createEnum(HsaReimbursementClaimStatus),
    alreadyClaimed: z.boolean(),
    hasTemplate: z.boolean(),
  }),
};
